import React, { FC } from "react";
import {
  DropdownItem as BaseDropdownItem,
  DropdownItemProps,
} from "reactstrap";

const DropdownItem: FC<DropdownItemProps> = ({ children, ...rest }) => {
  return <BaseDropdownItem {...rest}>{children}</BaseDropdownItem>;
};

export default DropdownItem;
